// extracted by mini-css-extract-plugin
export default {"cls1":"rsQVQMRC9P8ujn_1Tb8l","cls2":"qWELKp3GKI0_3cwncrkg rsQVQMRC9P8ujn_1Tb8l"};